import { AppBar, Grid, Toolbar, Link } from "@mui/material";
import CustomText from "./CustomText";
import ImageLoader from "./ImageLoader";
import { useLocation, useNavigate } from "react-router-dom";
import MenuRedirect from "./MenuRedirect";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";

const Navbar = () => {
  /**
   * Function to navigate between routes.
   * @type {Function}
   */
  const navigate = useNavigate();
  /**
   * Función que maneja la navegación a la página de inicio.
   * Utiliza la función `navigate` para redirigir al usuario a la ruta principal (`/`).
   * @function
   * @returns {void} No retorna ningún valor, solo realiza la navegación.
   */
  const handleHome = () => navigate(`/`);
  /**
   * Hook que obtiene la información sobre la ubicación actual utilizando `useLocation`.
   * @type {Location} Un objeto que contiene detalles sobre la ubicación actual, como el `pathname`.
   */
  const location = useLocation();

  /**
   * Valores extraídos del contexto `ScreenContext`, que proporcionan información sobre la pantalla.
   * `isMobile` es un valor booleano que indica si la vista actual corresponde a un dispositivo móvil.
   * `dimensionHeight` es la altura de la ventana del navegador.
   * @type {{isMobile: boolean, dimensionHeight: number}} Un objeto con las propiedades `isMobile` y `dimensionHeight`.
   */
  const { isMobile, isDesktop, dimensionWidth } = useContext(ScreenContext);
  const Dimension = dimensionWidth < 1270;
  return (
    <AppBar component="nav" position="fixed" sx={design.Back}>
      <Toolbar disableGutters>
        <Grid container width="100%">
          <Grid size={design.Grid1} />
          <Grid size={design.Grid1} sx={design.Align}>
            <Link edge="start" onClick={handleHome}>
              <ImageLoader
                src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Icono_Centro_Medico_Medam_Blue.png"
                alt="Icono_Centro_Medico_Medam_Blanco"
                width={'100%'}
                height={43}
              />
            </Link>
          </Grid>
          <Grid container size={design.Grid8} sx={design.Align}>
            {!Dimension &&
              menuItems.map((doc, index) => {
                const Local = location.pathname === doc.path;
                const handlenavigation = () => navigate(doc.path);
                return (
                  <CustomText
                    key={index}
                    variant="subtitle1"
                    color={"#847E7F"}
                    text={doc.name}
                    fontFamily="Plus Jakarta Sans"
                    sx={{
                      borderBottom: `2px solid ${Local ? "#847E7F" : "transparent"}`,
                      "&:hover": {
                        borderBottom: "2px solid #847E7F",
                      },
                      ...design.Text,
                    }}
                    onClick={handlenavigation}
                  >
                    {doc.name}
                  </CustomText>
                );
              })}
          </Grid>

          <Grid size={design.Grid1} sx={design.Align}>
            <MenuRedirect isMobile={isMobile} isDesktop={isDesktop} />
          </Grid>
          <Grid size={design.Grid1} />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;

const design = {
  Align: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  Text: {
    marginLeft: 4,
    marginRight: 4,
    fontWeight: 500,
  },
  Back: { backgroundColor: "#E1D9EA" },
  Grid1: { xs: 1, md: 1, xl: 1 },
  Grid8: { xs: 8, md: 8, xl: 8 },
};

const menuItems = [
  { name: "Inicio", path: "/" },
  { name: "Servicios", path: "/servicios" },
  { name: "Directorio de médicos", path: "/directorioMedico" },
  // { name: "Pre-ingreso", path: "/preRegistration" },
  { name: "¿Cómo llegar?", path: "/como-llegar" },
];
